<template lang="pug">
  table
    thead
      tr(v-if="verticalAxis == 1")
        th(v-if="workPlaceFlg") 市区町村（勤務地）
        th(v-else) 市区町村（所在地）
        th(v-for="(agg, index) in results[0].agg_result") {{ agg.month }}
      tr(v-else-if="verticalAxis == 2")
        th 職種
        th(v-for="(agg, index) in results[0].agg_result") {{ agg.month }}
      tr(v-else-if="verticalAxis == 3")
        th 業種
        th(v-for="(agg, index) in results[0].agg_result") {{ agg.month }}
      tr(v-else-if="verticalAxis == 4")
        th 掲載メディア
        th(v-for="(agg, index) in results[0].agg_result") {{ agg.month }}
      tr(v-else)
        th(v-if="workPlaceFlg") 都道府県（勤務地）
        th(v-else) 都道府県（所在地）
        th(v-for="(agg, index) in results[0].agg_result") {{ agg.month }}
    tbody(v-if="aggType == 1")
      tr(v-for="(result, index) in results")
        td {{result.vertical_axis_name}}
        td(v-for="(agg, index) in result.agg_result")
          a(:href="agg.master_url" target="_blank" rel="noopener noreferrer") {{ Number(agg.job_count).toLocaleString() }}件
    tbody(v-if="aggType == 2")
      tr(v-for="(result, index) in results")
        td {{result.vertical_axis_name}}
        td(v-for="(agg, index) in result.agg_result")
          a(:href="agg.master_url" target="_blank" rel="noopener noreferrer")
            span(v-if="agg.avg_salary_min !== null && agg.avg_salary_max !== null")
              | {{ Number(agg.avg_salary_min).toLocaleString() }}円
              br
              | ~ {{ Number(agg.avg_salary_max).toLocaleString() }}円
            span(v-else)
              | -
    tbody(v-if="aggType == 3")
      tr(v-for="(result, index) in results")
        td {{result.vertical_axis_name}}
        td(v-for="(agg, index) in result.agg_result")
          a(:href="agg.master_url" target="_blank" rel="noopener noreferrer")
            span(v-if="agg.avg_article_plan !== null") {{ Number(agg.avg_article_plan).toLocaleString("ja-JP") }}万円
            span(v-else) -
    .csv-download
      input.button-main(
        type="button"
        @click="openCsvDownloadModal"
        value="CSVダウンロード"
      )
</template>

<script>
  import { HumanErrorMessages } from '../../constants'

  export default {
    props: ['results', 'aggType', 'workPlaceFlg', 'verticalAxis'],
    methods: {
      downloadCSV () {
        let csv = '\ufeff'

        // ヘッダー
        const header = []
        header.push(this.getVerticalAxisName())

        this.results[0].agg_result.forEach((agg) => {
          header.push(agg.month)
        })
        csv += header.join()
        csv += '\n'

        // rowデータ（求人数、給与、広告予算）
        this.results.forEach((result) => {
          const row = []
          row.push(result.vertical_axis_name)
          result.agg_result.forEach((agg) => {
            if (this.aggType === '1') {
              row.push(`${agg.job_count}件`)
            } else if (this.aggType === '2') {
              if (agg.avg_salary_min !== null && agg.avg_salary_max !== null) {
                row.push(`${agg.avg_salary_min}円~${agg.avg_salary_max}円`)
              } else {
                row.push('')
              }
            } else if (this.aggType === '3') {
              if (agg.avg_article_plan !== null) {
                row.push(`${agg.avg_article_plan}万円`)
              } else {
                row.push('')
              }
            }
          })
          csv += row.join()
          csv += '\n'
        })

        const blob = new Blob([csv], { type: 'text/csv' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'result.csv'
        link.click()
      },
      getVerticalAxisName () {
        if (this.verticalAxis === '1') {
          if (this.workPlaceFlg) {
            return '市区町村（勤務地）'
          }
            return '市区町村（所在地）'
        } else if (this.verticalAxis === '2') {
          return '職種'
        } else if (this.verticalAxis === '3') {
          return '業種'
        }
        return '掲載メディア'
      },
      openCsvDownloadModal () {
        if (this.demo) {
          this.$store.dispatch('common/pushToastError', {
            error: new Error(HumanErrorMessages.FORBIDDEN),
          })
          return
        }

        this.$store.commit('common/setAggregateJobModalMode')
        this.$store.commit('common/showModal')
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/AggregateJobTable.vue